/* eslint-disable @typescript-eslint/no-explicit-any */
import { orderBy } from 'lodash';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import { AnalyticsNumberMetric } from './AnalyticsNumberMetric';
import { AnalyticsMetricContainer } from './AnalyticsMetric';
import { useState } from 'react';
import { Modal, Popover } from '@treams/treams-ui';

const AnalyticsConversationsMetricMore = styled.button`
	width: 100%;
	height: 30px;
	color: ${(props) => props.theme.colors.slateBlue};
	background-color: transparent;
	line-height: 40px;

	:hover {
		color: ${(props) => props.theme.colors.antracite};
	}

	:active {
		opacity: 0.5;
	}
`;

function AnalyticsConversationsMetricList(props: {
	metricGroupID: string;
	metric: graphql.AnalyticsConversationsMetric;
	totalUsers: number;
	limit?: number;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	return (
		<>
			{orderBy(props.metric.templates, (template) => template.value, 'desc')
				.slice(0, props.limit ?? 1000)
				.map((template, index) => (
					<AnalyticsMetricContainer key={index} my={1}>
						<AnalyticsNumberMetric
							metricGroupID={props.metricGroupID}
							metric={
								{
									id: props.metric.id,
									...template,
									threshold: props.metric.threshold,
								} as any
							}
							details={localize(template.template.title).text}
							subtitle={index === 0 ? t('analytics.metrics.conversation.topTemplate') : undefined}
							totalUsers={props.totalUsers}
						/>
					</AnalyticsMetricContainer>
				))}
		</>
	);
}

export function AnalyticsConversationsMetric(props: {
	metricGroupID: string;
	metric: graphql.AnalyticsConversationsMetric;
	totalUsers: number;
}) {
	const { t } = useTranslation();
	const [modalVisible, setModalVisible] = useState(false);

	return (
		<>
			{modalVisible && (
				<Popover visible center>
					<Modal height="auto">
						<Modal.Header
							title={t('analytics.metrics.conversation.modal.title')}
							onClose={() => setModalVisible(false)}
						/>

						<Modal.Contents>
							<AnalyticsConversationsMetricList
								metricGroupID={props.metricGroupID}
								metric={props.metric}
								totalUsers={props.totalUsers}
							/>
						</Modal.Contents>

						<Modal.Footer />
					</Modal>
				</Popover>
			)}

			<AnalyticsConversationsMetricList
				metricGroupID={props.metricGroupID}
				metric={props.metric}
				totalUsers={props.totalUsers}
				limit={2}
			/>

			{props.metric.templates.length > 2 && (
				<AnalyticsConversationsMetricMore
					onClick={() => {
						setModalVisible(true);
					}}
				>
					{t('analytics.metrics.conversation.modal.openButton')}
				</AnalyticsConversationsMetricMore>
			)}
		</>
	);
}
